import { Injectable } from '@angular/core';

import { INVESTIGATOR_ROUTES_FEATURE_FLAGS } from '@shared/constants/feature-flags-guards/investigator-feature-flags.const';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { BasicRedirectToNextTabGuard } from '@shared/guards/basic-redirect-to-next-tab.guard';
import { Flags } from '@shared/services/launch-darkly.service';

@Injectable({
  providedIn: 'root',
})
export class InvestigatorForecastGuard extends BasicRedirectToNextTabGuard {
  protected prefix = `/${ROUTING_PATH.INVESTIGATOR.INDEX}`;
  protected defaultNavigateUrl = `/${this.prefix}/${ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_FORECAST.INDEX}/${ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_FORECAST.SETTINGS}`;
  protected featureFlag = 'tab_forecast_investigator_forecast' as keyof Flags;
  protected routerPathsAndFeatureFlags = INVESTIGATOR_ROUTES_FEATURE_FLAGS;
}
